/* KBW flooring gallery — KBW-88.

   One job: clicking a thumbnail swaps the big picture, and the label naming
   the floor follows it. Same behaviour as the cabinet style header
   (kbw-style-header.js): wait for the new picture to decode, then swap, so
   the change is one clean step rather than a half-drawn frame.

   Everything is printed server-side. With scripting off the first picture,
   its label and the thumbnails still show; they just do not change it.

   Markup contract:
     [data-kbw-flg]                 gallery root
     [data-kbw-flg-stage]           the big <img>
     [data-kbw-flg-thumb]           one button per picture, carrying
                                    data-src, data-srcset, data-alt, data-w,
                                    data-h, and -- only when a product is
                                    linked -- data-url, data-name, data-meta
     [data-kbw-flg-cap]             the label (<a>), absent when no picture
                                    in the gallery has a product
     [data-kbw-flg-cap-name|meta]   its two text parts
*/

(function () {
  'use strict';

  var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function setup(root) {
    if (root.dataset.kbwFlgReady === '1') return;

    var stage = root.querySelector('[data-kbw-flg-stage]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-kbw-flg-thumb]'));
    if (!stage || thumbs.length < 2) return;

    root.dataset.kbwFlgReady = '1';

    var cap = root.querySelector('[data-kbw-flg-cap]');
    var capName = cap && cap.querySelector('[data-kbw-flg-cap-name]');
    var capMeta = cap && cap.querySelector('[data-kbw-flg-cap-meta]');

    var current = thumbs.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; })[0] || thumbs[0];
    var ticket = 0;

    function mark(btn) {
      thumbs.forEach(function (t) {
        t.setAttribute('aria-pressed', t === btn ? 'true' : 'false');
      });
    }

    function label(btn) {
      if (!cap) return;
      var url = btn.getAttribute('data-url');
      if (!url) {
        /* No product behind this picture: no label, and no link left behind. */
        cap.hidden = true;
        cap.removeAttribute('href');
        return;
      }
      cap.setAttribute('href', url);
      if (capName) capName.textContent = btn.getAttribute('data-name') || '';
      if (capMeta) {
        var meta = btn.getAttribute('data-meta') || '';
        capMeta.textContent = meta;
        capMeta.hidden = !meta;
      }
      cap.hidden = false;
    }

    function swap(btn) {
      var srcset = btn.getAttribute('data-srcset');
      if (srcset) stage.setAttribute('srcset', srcset);
      else stage.removeAttribute('srcset');
      stage.setAttribute('src', btn.getAttribute('data-src'));
      stage.setAttribute('alt', btn.getAttribute('data-alt') || '');
      if (btn.getAttribute('data-w')) stage.setAttribute('width', btn.getAttribute('data-w'));
      if (btn.getAttribute('data-h')) stage.setAttribute('height', btn.getAttribute('data-h'));
      label(btn);
      current = btn;

      if (!motion || !motion.matches) {
        stage.classList.remove('is-in');
        void stage.offsetWidth; /* restart the fade */
        stage.classList.add('is-in');
      }
    }

    function show(btn) {
      if (btn === current) { mark(btn); return; }

      /* The pressed state answers at once; the picture follows when ready. */
      mark(btn);
      var mine = ++ticket;

      var next = new Image();
      next.sizes = stage.getAttribute('sizes') || '';
      var srcset = btn.getAttribute('data-srcset');
      if (srcset) next.srcset = srcset;
      next.src = btn.getAttribute('data-src');

      var done = function () { if (mine === ticket) swap(btn); };
      var failed = function () {
        /* Leave the picture that works on screen and say so. */
        if (mine === ticket) mark(current);
      };

      if (next.decode) {
        next.decode().then(done, function () {
          if (next.complete && next.naturalWidth) done(); else failed();
        });
      } else {
        next.onload = done;
        next.onerror = failed;
      }
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { show(btn); });
    });

    /* The theme editor: picking a Gallery picture block shows that picture. */
    root.addEventListener('shopify:block:select', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-kbw-flg-thumb]') : null;
      if (btn) show(btn);
    });
  }

  function setupAll() {
    var roots = document.querySelectorAll('[data-kbw-flg]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  // The theme editor re-renders a section in place.
  document.addEventListener('shopify:section:load', setupAll);
})();
